import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-555bb4d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-white text-sm md:text-base mb-5" }
const _hoisted_2 = { class: "swiper-style" }
const _hoisted_3 = {
  class: "card-banner-parent w-full bg-cover bg-center bg-no-repeat flex items-center",
  style: {"background-image":"url('https://picsum.photos/1024/736')"}
}
const _hoisted_4 = { class: "flex flex-col h-full w-full items-end justify-end" }
const _hoisted_5 = { class: "flex flex-col bg-black-black bg-opacity-40 justify-center h-4/6 md:h-full py-2 px-4 w-full md:w-5/12 lg:w-1/4" }
const _hoisted_6 = { class: "text-2xl md:text-5xl w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "flex items-center space-x-4 w-max"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "aria-hidden": "true",
      role: "img",
      class: "iconify iconify--ic",
      width: "32",
      height: "32",
      preserveAspectRatio: "xMidYMid meet",
      viewBox: "0 0 24 24"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "currentColor",
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zM9.5 16.5v-9l7 4.5l-7 4.5z"
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-sm md:text-base" }, "Watch Gameplay")
  ])
], -1))
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col space-y-4"
}
const _hoisted_9 = { class: "card-banner-parent w-full relative" }
const _hoisted_10 = {
  key: 1,
  class: "card-banner-top w-full",
  style: {"display":"block","overflow":"hidden"}
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "card-banner-top w-full",
  style: {"display":"block","overflow":"hidden"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex flex-col bottom-0 md:top-0 right-0 absolute bg-gradient-to-r from-black-black to-black-border z-20 opacity-80 justify-center h-4/6 md:h-full py-2 px-4 w-full md:w-5/12 lg:w-1/4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-md truncate font-bold text-gray-text" }, "Featured Games", -1))
const _hoisted_16 = {
  key: 0,
  class: "text-md md:text-xl truncate font-bold hover:underline"
}
const _hoisted_17 = {
  key: 0,
  class: "text-gray-text truncate h-5 display-block"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["onMouseover"]
const _hoisted_21 = {
  key: 1,
  class: "card-preview-top w-full",
  style: {"display":"block","overflow":"hidden"}
}
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-md md:text-xl truncate font-bold" }, "Available Now", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-md truncate font-bold" }, "Play for Free", -1))
const _hoisted_25 = { class: "mt-8" }
const _hoisted_26 = { class: "flex space-x-8 uppercase text-sm mx-12 md:mx-28" }
const _hoisted_27 = { class: "relative" }
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col space-y-4 card-cover"
}
const _hoisted_29 = { class: "card-img-parent rounded-2xl w-full" }
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = {
  key: 0,
  class: "text-md md:text-xl truncate font-bold hover:underline"
}
const _hoisted_32 = {
  key: 0,
  class: "text-gray-text truncate h-5 display-block"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev-el absolute left-0 top-1/2 ml-2 md:ml-8 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--ic",
    width: "32",
    height: "32",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2S2 6.48 2 12zm18 0c0 4.42-3.58 8-8 8s-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8zM8 12l4-4l1.41 1.41L11.83 11H16v2h-4.17l1.59 1.59L12 16l-4-4z"
    })
  ])
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next-el absolute right-0 top-1/2 mr-2 md:mr-8 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--ic",
    width: "32",
    height: "32",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10s10-4.48 10-10zM4 12c0-4.42 3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8zm12 0l-4 4l-1.41-1.41L12.17 13H8v-2h4.17l-1.59-1.59L12 8l4 4z"
    })
  ])
], -1))
const _hoisted_36 = { class: "mt-8 mx-12 md:mx-28" }
const _hoisted_37 = { class: "flex space-x-8 text-sm" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-2 uppercase border-red-primary p-2 active" }, "Popular Genre", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode("All Genre")
const _hoisted_40 = { class: "grid grid-cols-2 md:grid-cols-4 mt-8 gap-4" }
const _hoisted_41 = {
  key: 0,
  class: "flex flex-col xl:flex-row text-center xl:text-left min-h-full justify-between items-center px-2 py-4 md:px-3 border-2 border-gray-500 hover:border-red-hover hover:bg-red-hover cursor-pointer rounded-lg transition-all duration-200"
}
const _hoisted_42 = { class: "text-md font-bold truncate" }
const _hoisted_43 = { class: "text-xs flex" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Games", -1))
const _hoisted_45 = { class: "mt-24 lg:mx-28 hidden" }
const _hoisted_46 = { class: "flex flex-col lg:flex-row w-full h-full lg:space-x-20" }
const _hoisted_47 = { class: "flex flex-col text-md lg:text-xl min-h-full w-full lg:w-2/3" }
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<span class=\"border-b-2 uppercase w-max mx-12 md:mx-28 lg:mx-0 border-red-primary\" data-v-555bb4d2>What&#39;s New</span><div class=\"hidden lg:grid grid-cols-1 xl:grid-cols-2 gap-4 mt-10 h-full\" data-v-555bb4d2><a href=\"#\" class=\"h-full xl:row-span-2\" data-v-555bb4d2><div class=\"bg-center bg-cover rounded-lg\" style=\"background-image:url(&#39;https://picsum.photos/400/600&#39;);\" data-v-555bb4d2><div class=\"px-7 xl:px-14 py-8 flex flex-col xl:justify-end justify-center items-start w-full h-full bg-gradient-to-b from-transparent to to-red-primary bg-opacity-40 space-y-4\" data-v-555bb4d2><span class=\"text-4xl font-bold\" data-v-555bb4d2>Season 9 GameX Valorant Tournament</span><span class=\"text-md\" data-v-555bb4d2>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. </span></div></div></a><a href=\"#\" class=\"h-full\" data-v-555bb4d2><div class=\"bg-center bg-cover rounded-lg\" style=\"background-image:url(&#39;https://picsum.photos/400/600&#39;);\" data-v-555bb4d2><div class=\"px-7 py-8 flex items-center w-full h-full bg-gradient-to-r from-black-primary to to-transparent bg-opacity-50\" data-v-555bb4d2><div class=\"flex flex-col xl:w-1/2 space-y-4\" data-v-555bb4d2><span class=\"text-4xl font-bold\" data-v-555bb4d2>League Of Legend Big Tournament</span><span class=\"text-md\" data-v-555bb4d2>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. </span></div></div></div></a><a href=\"#\" class=\"h-full\" data-v-555bb4d2><div class=\"bg-center bg-cover rounded-lg\" style=\"background-image:url(&#39;https://picsum.photos/400/600&#39;);\" data-v-555bb4d2><div class=\"px-7 py-8 flex justify-end items-center w-full h-full bg-gradient-to-l from-black-primary to to-transparent bg-opacity-50\" data-v-555bb4d2><div class=\"flex flex-col xl:w-1/2 space-y-4\" data-v-555bb4d2><span class=\"text-4xl font-bold\" data-v-555bb4d2>Take part in an Epic Battle</span><span class=\"text-md\" data-v-555bb4d2>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. </span></div></div></div></a></div>", 2)
const _hoisted_50 = { class: "relative lg:hidden min-h-full" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "h-full row-span-2"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-img-top bg-center bg-cover rounded-lg",
    style: {"background-image":"url('https://picsum.photos/400/600')"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-8 flex items-center w-full h-full bg-gradient-to-b from-transparent to to-red-primary bg-opacity-40 space-y-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col xl:w-1/2 space-y-4" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "text-2xl md:text-4xl font-bold" }, "Season 9 GameX Valorant Tournament"),
        /*#__PURE__*/_createElementVNode("span", { class: "text-md" }, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. ")
      ])
    ])
  ])
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "h-full"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-img-top bg-center bg-cover rounded-lg",
    style: {"background-image":"url('https://picsum.photos/400/600')"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-8 flex items-center w-full h-full bg-gradient-to-r from-black-primary to to-transparent bg-opacity-50" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col xl:w-1/2 space-y-4" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "text-4xl font-bold" }, "League Of Legend Big Tournament"),
        /*#__PURE__*/_createElementVNode("span", { class: "text-md" }, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. ")
      ])
    ])
  ])
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "h-full"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-img-top bg-center bg-cover rounded-lg",
    style: {"background-image":"url('https://picsum.photos/400/600')"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-8 flex justify-end items-center w-full h-full bg-gradient-to-l from-black-primary to to-transparent bg-opacity-50" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col xl:w-1/2 space-y-4" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "text-4xl font-bold" }, "Take part in an Epic Battle"),
        /*#__PURE__*/_createElementVNode("span", { class: "text-md" }, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. ")
      ])
    ])
  ])
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev-el3 absolute left-0 top-1/2 ml-2 md:ml-8 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--ic",
    width: "32",
    height: "32",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2S2 6.48 2 12zm18 0c0 4.42-3.58 8-8 8s-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8zM8 12l4-4l1.41 1.41L11.83 11H16v2h-4.17l1.59 1.59L12 16l-4-4z"
    })
  ])
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next-el3 absolute right-0 top-1/2 mr-2 md:mr-8 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--ic",
    width: "32",
    height: "32",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10s10-4.48 10-10zM4 12c0-4.42 3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8zm12 0l-4 4l-1.41-1.41L12.17 13H8v-2h4.17l-1.59-1.59L12 8l4 4z"
    })
  ])
], -1))
const _hoisted_56 = { class: "flex flex-col mx-0 md:mx-28 lg:w-1/3 mt-8 lg:mt-0" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-b-2 mx-12 md:mx-0 text-md lg:text-xl border-red-primary w-max uppercase" }, "Frequently Asked Question", -1))
const _hoisted_58 = { class: "flex flex-col mx-12 md:mx-0" }
const _hoisted_59 = { class: "text-md md:text-3xl font-bold" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-primary-full" }, " View All Note ", -1))
const _hoisted_62 = { class: "mt-24 mx-12 md:mx-28 hidden" }
const _hoisted_63 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-20 lg:gap-16" }
const _hoisted_64 = { class: "flex space-x-4 mb-4 justify-center md:justify-start sm:col-span-2" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--ph",
  width: "32",
  height: "32",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M220 96a92 92 0 1 0-152 69.7V240a12 12 0 0 0 5.7 10.2a11.9 11.9 0 0 0 11.7.5l42.6-21.3l42.6 21.3a11.6 11.6 0 0 0 5.4 1.3a11.8 11.8 0 0 0 6.3-1.8A12 12 0 0 0 188 240v-74.3A91.9 91.9 0 0 0 220 96ZM60 96a68 68 0 1 1 68 68a68.1 68.1 0 0 1-68-68Zm104 124.6l-30.6-15.3a12.1 12.1 0 0 0-10.8 0L92 220.6v-39.9a92.4 92.4 0 0 0 72 0ZM128 148a52 52 0 1 0-52-52a52 52 0 0 0 52 52Zm0-80a28 28 0 1 1-28 28a28.1 28.1 0 0 1 28-28Z"
  })
], -1))
const _hoisted_66 = { class: "uppercase text-md md:text-xl border-b-2 border-red-primary" }
const _hoisted_67 = { class: "flex flex-col md:flex-row items-center space-y-4 md:space-y-0" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--simple-icons",
  width: "50",
  height: "50",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm-.262 3.678h2.584a.343.343 0 0 1 .33.435l-2.03 6.918l1.905-.582l-.408 1.385l-1.924.56l-1.248 4.214h6.676a.343.343 0 0 1 .328.437l-.582 2a.459.459 0 0 1-.44.33H6.733l1.723-5.822l-1.906.58l.42-1.361l1.91-.58l2.422-8.18a.456.456 0 0 1 .437-.334Z"
  })
], -1))
const _hoisted_69 = { class: "flex flex-col text-center md:ml-4" }
const _hoisted_70 = { class: "font-bold text-md md:text-xl" }
const _hoisted_71 = { class: "text-sm text-gray-text" }
const _hoisted_72 = { class: "text-xl md:text-2xl" }
const _hoisted_73 = { class: "my-20 mx-12 md:mx-28 hidden" }
const _hoisted_74 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-6" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--fluent",
  width: "60",
  height: "50",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M16 11a4 4 0 1 0 0-8a4 4 0 0 0 0 8Zm-6-3.5a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0Zm19 0a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0ZM9.377 13a3.983 3.983 0 0 0-.877 2.5V23c0 1.235.298 2.4.827 3.427A5 5 0 0 1 2 22v-6.5A2.5 2.5 0 0 1 4.5 13h4.877Zm13.296 13.427A7.468 7.468 0 0 0 23.5 23v-7.5c0-.946-.328-1.815-.877-2.5H27.5a2.5 2.5 0 0 1 2.5 2.5V22a5 5 0 0 1-7.327 4.427ZM12.5 13a2.5 2.5 0 0 0-2.5 2.5V23a6 6 0 0 0 12 0v-7.5a2.5 2.5 0 0 0-2.5-2.5h-7Z"
  })
], -1))
const _hoisted_76 = { class: "flex flex-col" }
const _hoisted_77 = { class: "text-2xl md:text-3xl" }
const _hoisted_78 = { class: "text-gray-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_swiper, {
          ref: "slideSwiper",
          autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
          navigation: {
      nextEl: '.swiper-button-next-el2',
      prevEl: '.swiper-button-prev-el2',
    },
          modules: _ctx.modules,
          pagination: {
             clickable: true,
            dynamicBullets: true,
          },
          breakpoints: {
      '1024': {
        slidesPerView: 1,
      },
      '1440': {
        slidesPerView: 1,
      },
    },
          class: "swiper2"
        }, {
          default: _withCtx(() => [
            false
              ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.featuredTitle), 1),
                          _hoisted_7
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featuredGames, (game, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                default: _withCtx(() => [
                  (game.details)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          (game.game.gameId)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'viewGamesProfile', params: { gameId: game.game.gameId } }
                              }, {
                                default: _withCtx(() => [
                                  (game.details.gallery.headerImage)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "card-banner-top w-full",
                                        style: _normalizeStyle('background: url(' + _ctx.assetURL + 'blob/games/' + game.game.gameId + '/gallery/' +  game.details.gallery.headerImage + ') #000; background-repeat: no-repeat; background-size: cover; background-position: center')
                                      }, null, 4))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("img", {
                                          class: "h-full w-full",
                                          src: require(`@/assets/images/default-cover.png`)
                                        }, null, 8, _hoisted_11)
                                      ]))
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["card-banner-parent top-0 left-0 w-full absolute z-10 transition-opacity duration-75", { 'opacity-100': _ctx.imageActive, 'opacity-0': (_ctx.imageActive == false) }])
                          }, [
                            (_ctx.headerImage)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "card-banner-top card-image w-full",
                                  style: _normalizeStyle('background: url(' + _ctx.assetURL + 'blob/games/' + game.game.gameId + '/gallery/' + _ctx.headerImage + ') #000; background-repeat: no-repeat; background-size: cover; background-position: center')
                                }, null, 4))
                              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("img", {
                                    class: "h-full w-full",
                                    src: require(`@/assets/images/default-cover.png`)
                                  }, null, 8, _hoisted_13)
                                ]))
                          ], 2),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createVNode(_component_router_link, {
                              to: { name: 'viewGamesProfile', params: { gameId: game.game.gameId } }
                            }, {
                              default: _withCtx(() => [
                                (game.game.title)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(game.game.title), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            (game.details.about.about == null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                              : (_openBlock(), _createElementBlock("small", {
                                  key: 1,
                                  class: "text-gray-text truncate",
                                  innerHTML: game.details.about.about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)
                                }, null, 8, _hoisted_18)),
                            (game.details.gallery.galleryImages)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  (game.details.gallery.galleryImages.length > 0 )
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["grid gap-2 lg:gap-3 my-3 max-h-72 md:max-h-80 lg:max-h-full", game.details.gallery.galleryImages.length <= 1 ?'grid-cols-1': game.details.gallery.galleryImages.length >= 2 ?'grid-cols-2': ''])
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((game.details.gallery.galleryImages).slice(0,4), (gallery, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "card-preview-parent w-full"
                                          }, [
                                            gallery
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: "card-preview-top w-full",
                                                  onMouseover: ($event: any) => (_ctx.changeImage(gallery)),
                                                  onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideImage())),
                                                  style: _normalizeStyle('background: url(' + _ctx.assetURL + 'blob/games/' + game.game.gameId + '/gallery/' + gallery + ') #000; background-repeat: no-repeat; background-size: cover; background-position: center')
                                                }, null, 44, _hoisted_20))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                  _createElementVNode("img", {
                                                    class: "h-full w-full",
                                                    src: require(`@/assets/images/default-cover-small.png`)
                                                  }, null, 8, _hoisted_22)
                                                ]))
                                          ]))
                                        }), 128))
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_23,
                            _hoisted_24
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["navigation", "modules"])
      ]),
      _createElementVNode("section", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: _normalizeClass(["border-2 border-transparent p-2 hover:border-red-primary cursor-pointer transition-all duration-200", _ctx.sortGamesTab == 'trending'?'active':'hover:text-red-hover']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortGamesTrending(), _ctx.sortGamesTab = 'trending'))
          }, "Trending Games", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["border-2 border-transparent p-2 hover:border-red-primary cursor-pointer transition-all duration-200", _ctx.sortGamesTab == 'latest'?'active':'hover:text-red-hover']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortGamesLatest(), _ctx.sortGamesTab = 'latest'))
          }, "Newly Added Games", 2)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_swiper, {
            ref: "slideSwiper",
            navigation: {
            nextEl: '.swiper-button-next-el',
            prevEl: '.swiper-button-prev-el',
          },
            modules: _ctx.modules,
            breakpoints: {
            '320': {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            '768': {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            '1024': {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            '1440': {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          },
            class: "swiper mx-12 md:mx-28 mt-8"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayGames, (game, index) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                  default: _withCtx(() => [
                    (game.details)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          (game.game.gameId)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'viewGamesProfile', params: { gameId: game.game.gameId } }
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_29, [
                                    (game.details.gallery.headerImage)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "card-img-top rounded-2xl w-full",
                                          style: _normalizeStyle('background: url(' + _ctx.assetURL + 'blob/games/' + game.game.gameId + '/gallery/' + game.details.gallery.headerImage + ') #000; background-repeat: no-repeat; background-size: cover; background-position: center')
                                        }, null, 4))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "card-img-top rounded-2xl w-full",
                                          style: _normalizeStyle('background: url(' + require(`@/assets/images/default-cover-small.png`) + '); background-repeat: no-repeat; background-size: cover;')
                                        }, null, 4))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_router_link, {
                              class: _normalizeClass('flex w-full'),
                              to: { name: 'viewGamesProfile', params: { gameId: game.game.gameId } }
                            }, {
                              default: _withCtx(() => [
                                (game.game.title)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(game.game.title), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            (game.details.about.about == null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                              : (_openBlock(), _createElementBlock("small", {
                                  key: 1,
                                  class: "text-gray-text truncate",
                                  innerHTML: game.details.about.about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)
                                }, null, 8, _hoisted_33))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["navigation", "modules"]),
          _hoisted_34,
          _hoisted_35
        ])
      ]),
      _createElementVNode("section", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createVNode(_component_router_link, {
            to: { name: 'viewGamesGenre' },
            class: "border-2 p-2 uppercase hover:text-red-hover border-transparent hover:border-red-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGenre.slice(0,8), (genre, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: { name: 'viewGamesGenre', params: { category: genre.value } },
              key: index
            }, {
              default: _withCtx(() => [
                (genre.count > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("span", _hoisted_42, _toDisplayString(genre.value), 1),
                      _createElementVNode("span", _hoisted_43, [
                        _createTextVNode(_toDisplayString(genre.count), 1),
                        _hoisted_44
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_swiper, {
                ref: "slideSwiper",
                navigation: {
                nextEl: '.swiper-button-next-el3',
                prevEl: '.swiper-button-prev-el3',
              },
                modules: _ctx.modules,
                breakpoints: {
                '320': {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
              },
                class: "swiper3 mx-12 md:mx-28 mt-8 h-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _hoisted_51
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _hoisted_52
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _hoisted_53
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["navigation", "modules"]),
              _hoisted_54,
              _hoisted_55
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: "flex flex-col border-b-2 space-y-6 border-black-border pb-10 mt-10"
                }, [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.questionTitle), 1),
                  _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.questionDesc), 1)
                ])
              }), 64)),
              _hoisted_61
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
            return _createElementVNode("div", {
              key: index,
              class: "grid grid-cols-1 sm:grid-cols-2 md:flex md:flex-col md:space-y-10 items-center gap-8 md:gap-0 mb-8"
            }, [
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.coinTitle), 1)
              ]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: "flex flex-col md:flex-row items-center justify-between w-full"
                }, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.coinName), 1),
                      _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.coinSubtitle), 1)
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.coinNum), 1)
                ])
              }), 64))
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("section", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
            return _createElementVNode("div", {
              key: index,
              class: "flex space-x-4 items-center m-2"
            }, [
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.iconNum), 1),
                _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.iconTitle), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ])
  ]))
}